import React from "react";
import { createContext, useState } from "react";

export const NavIconContext = createContext();

const NavIconContextProvider =(props)=>{

    const [iconState,setIconState]=useState("newfeed");
    const [addpost,setAddpost]=useState(false);
    const [notifcationShow,setNotificationShow]=useState(false);



    return(
        <NavIconContext.Provider value={{
            iconState,setIconState,addpost,setAddpost,
            notifcationShow,setNotificationShow
            
            }}>
            
            
            {props.children}
        </NavIconContext.Provider>
    )

}

export default NavIconContextProvider;